import React from 'react';
import PropTypes from 'prop-types';
import { Heading_1 as Heading1, PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import BackButton from '../../BackButton/BackButton';
import styles from '../bankPaymentRedemption.module.scss';

export const WaitingForConsentView = ({ onRelaunch, isLoading, error }) => (
  <div
    className={styles.container}
    data-test-id="bank-payment-waiting-consent-view"
  >
    <div className={styles.header}>
      <Heading1>{dictionary.bankPayment.labels.waitingTitle}</Heading1>
    </div>
    <p className={styles.body}>{dictionary.bankPayment.copy.waitingBody}</p>
    {error && (
      <p className={styles.error} data-test-id="bank-payment-waiting-error">
        {dictionary.bankPayment.errors.initiateFailed}
      </p>
    )}
    <div className={styles.ctaWrapper}>
      <PrimaryButton
        onClick={onRelaunch}
        label={
          isLoading
            ? dictionary.bankPayment.labels.connectingCta
            : dictionary.bankPayment.labels.waitingCta
        }
        disabled={isLoading}
        className={styles.cta}
        data-test-id="bank-payment-waiting-cta"
      />
    </div>
    <BackButton className={styles.backButton} />
  </div>
);

WaitingForConsentView.propTypes = {
  onRelaunch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.any
};

export default WaitingForConsentView;
